import modelBase from "./model-base.model";

var masterConfigurationModel = {
    uploadMasterConfiguration: (successCallBack, failureCallBack, recordType, countryCode, colNo, file, location, DOWNLOAD_YN) => {
        var path = "/api" + (location ? location : '') + "/masterConfiguration/excelUpload?CountryCode=" + countryCode + '&RecordType=' + recordType + '&ColNo=' + colNo;
        if (DOWNLOAD_YN) {
            modelBase.postDownload(successCallBack, failureCallBack, path, { body: file }, "ConfigurationMasterResult" + ".xlsx");
        } else {
            modelBase.post(successCallBack, failureCallBack, path, { body: file });
        }

    },
    downloadTemplate: (successCallBack, failureCallBack, recordType, sub) => {

        let params = {
            sortBy: "",
            orderBy: "",
            pageIndex: 0,
            pageSize: 100,
            storedProcedureCode: "21",
            params: [
                {
                    code: "57",
                    value: sub
                },
                {
                    code: "56",
                    value: recordType
                }
            ],
            excelSheetNames: ["Data"]
        }

        var path = `/api/executesp/export/tr/file`;
        modelBase.postDownload(successCallBack, failureCallBack, path, { body: params }, "ConfigurationMasterData" + ".xlsx");
    },
    downloadManual: (successCallBack, failureCallBack, manualId, name) => {
        const id = {
            encryptedFileId: manualId
        }

        Object.assign(id);
        let qs = '?' + modelBase.toQueryString(id);

        modelBase.getDownload(successCallBack, failureCallBack, `/api/MasterConfiguration/download/manual${qs}`, { params: null }, "Manual_" + name + ".zip");
    },
    downloadData: (successCallBack, failureCallBack, recordType, subsidiaryCode, locations) => {
        let params = {
            sortBy: "",
            orderBy: "",
            pageIndex: 0,
            pageSize: 100,
            storedProcedureCode: "22",
            params: [
                {
                    code: "62",
                    value: subsidiaryCode
                },
                {
                    code: "56",
                    value: recordType
                },
                {
                    code: "58",
                    value: ""
                },
                {
                    code: "59",
                    value: ""
                },
                {
                    code: "60",
                    value: ""
                },
                {
                    code: "61",
                    value: ""
                },
                {
                    code: "24",
                    value: ""
                },
                {
                    code: "2",
                    value: ""
                }
            ],
            excelSheetNames: ["Data"]
        }
        const location = locations ? locations.split(',').pop() : ''
        const path = `/api${location}/file/export/tr/file`;
        modelBase.postDownload(successCallBack, failureCallBack, path, { body: params }, "ConfigurationMasterData" + ".xlsx");
    },
    downloadMCList: (successCallBack, failureCallBack, filter) => {

        let url = "/api/MasterConfiguration/export?SubsidiaryCode=" + filter.subsidiaryCode + "&RecordType=" + filter.recordType + "&IncludeBlank=" + filter.includeSystemYN + "&SortBy=&OrderBy=&PageIndex=" + filter.pageIndex + "&PageSize=0";
        modelBase.postDownload(successCallBack, failureCallBack, url, { body: null }, "ConfigurationMaster" + ".xlsx");
    },
    addDeleteMasterConfiguration: (successCallBack, failureCallBack, country, recordType, data, location) => {

        let params = {
            "countryCode": country,
            "recordType": recordType,
            "dataField": data
        }
        let url = "/api" + (location ? location : '') + "/MasterConfiguration/adddelete";
        modelBase.post(successCallBack, failureCallBack, url, { body: params });
    },
    getConfigMasterDataList: (successCallBack, failureCallBack, filter) => {

        const location = filter.location ? filter.location.split(',').pop() : ''
        // console.log('filter=====>', filter, location)
        const url = `/api${location}/MasterConfiguration/data?SubsidiaryCode=${filter.subsidiaryCode}
        &RecordType=${filter.recordType}&ConditionField1=${filter.condition1.code}
        &ConditionField2=${filter.condition2.code}&ConditionValue1=${filter.condition1Value}
        &ConditionValue2=${filter.condition2Value}&SortBy=&OrderBy=&PageIndex=${filter.pageIndex}
        &PageSize=${filter.pageSize}`;

        modelBase.get(successCallBack, failureCallBack, url);
    },
    getConfigMasterDetailsList: (successCallBack, failureCallBack, sub, recType, location) => {
        var loc = location == undefined ? '' : location.split(',').pop()
        let url = "/api" + loc + "/MasterConfiguration/details?SubsidiaryCode=" + sub + "&RecordType=" + recType;
        modelBase.get(successCallBack, failureCallBack, url);
    },
    getConfigMasterList: (successCallBack, failureCallBack, filter) => {
        let url = "/api/MasterConfiguration?SubsidiaryCode=" + filter.subsidiaryCode + "&RecordType=" + filter.recordType + "&IncludeBlank=" + filter.includeSystemYN + "&SortBy=&OrderBy=&PageIndex=" + filter.pageIndex + "&PageSize=" + filter.pageSize;
        modelBase.get(successCallBack, failureCallBack, url);
    },
    checkAuthorization: (successCallBack, failureCallBack) => {

        let url = "/api/MasterConfiguration/authCheck";
        modelBase.get(successCallBack, failureCallBack, url);
    },
}

export default masterConfigurationModel;
